module.exports = __webpack_public_path__ + "assets/img/image(2).825c655f.png";